import { addStyles } from 'ethcss'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'
import { IStyles } from '../../../../theme'

const catalogTemplateUploadLogTasksStyles: IStyles = {
    list: {
        borderTop: `1px solid var(--var-module-app-component-app-style-border, ${defaultThemeStyles.border})`,
    },
}

addStyles(catalogTemplateUploadLogTasksStyles)
export default catalogTemplateUploadLogTasksStyles
